<template>
  <div :class="`flex flex-1 min-h-[6em] ${preview ? 'cursor-pointer bg-white' : 'mx-2 my-2'}`">
    
    <!-- Image section -->
    <div 
      v-if="tourSettings?.points_display_image"
      :class="`flex h-28 w-28 relative overflow-hidden bg-gray-200 ${preview ? ' rounded-l-lg' : 'rounded-lg'}`"
    >
      <img 
        v-if="image" 
        class="object-cover h-full w-full" 
        :alt="title" 
        :src="image" 
      />
      <div v-if="icon" class="absolute m-2">
        <img class="h-8" :alt="title" :src="icon"/>
      </div>
    </div>
    
    <!-- Content section -->
    <div class="flex flex-1 flex-col px-3 overflow-hidden justify-between">
      <div>
        <div :class="`${preview ? 'pt-3' : ''}`">
          <p class="text-sm font-bold line-clamp-2">
            {{ showMultiLingualText(title, name, true) }}
          </p>
        </div>
        
        <p v-if="description" class="text-sm line-clamp-4 pt-1">
          {{ showMultiLingualText(description) }}
        </p>
      </div>
      
      <div v-if="$slots.default" class="py-2 relative mt-auto">
        <slot />
      </div>
    </div>
    
    <!-- Icon section (when no image display) -->
    <div 
      v-if="!tourSettings?.points_display_image"
      class="flex items-center justify-center mx-2 overflow-hidden"
    >
      <img v-if="icon" class="w-10" :alt="title" :src="icon"/>
    </div>
    
    <!-- Chevron icon -->
    <div :class="`flex items-center p-2 ${activeRoute ? 'hidden' : ''}`">
      <!-- GPS Lock indicator -->
      <div v-if="isGPSLocked" class="mr-2">
        <LockClosedIcon class="w-5 h-5 text-red-500" title="GPS Locked - Move closer to unlock" />
      </div>
      <ChevronRightIcon class="w-5 h-5 text-gray-400"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ChevronRightIcon, LockClosedIcon } from '@heroicons/vue/24/outline'
import { showMultiLingualText } from '../utils/languageUtils'

export default {
  name: 'VueListItemTemplate',
  components: {
    ChevronRightIcon,
    LockClosedIcon
  },
  props: {
    icon: {
      type: String,
      default: null
    },
    image: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    preview: {
      type: Boolean,
      default: false
    },
    activeRoute: {
      type: Boolean,
      default: false
    },
    isGPSLocked: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('settings', ['tourSettings'])
  },
  methods: {
    showMultiLingualText(text, altText = null, showFirstLanguage = false) {
      return showMultiLingualText(text, altText, showFirstLanguage, this.$i18n.locale)
    }
  }
}
</script>